import { call, put, select, takeEvery } from 'redux-saga/effects';
import { SET_PROGRESS_REPORT, GET_PROGRESS_REPORT, SAVE_PROGRESS_REPORT } from 'store/key';
import { produce } from 'utility/general';
import API from 'api/call';
import { safeSaga } from 'store';
import { PROGRESS_REPORT } from 'utility/postApprovalLookUp';
import { setGlobal } from 'store/global/reducer';

const initialState = {
    // reportData: null,
    remoteDetail: {},
    // rows: [],
    // remoteDocIds: [],
    isLoading: false,
    // forceErrorDisplay: false,
};

// function* upDataInitial(action) {
//     const { key, value } = action.payload;
//     const { susarReport } = yield select();
//     susarReport[key] = value;
//     yield put({
//         type: SET_SUSAR_REPORT,
//         payload: susarReport,
//     });
// }

function* saveProgressReport(action) {
    const { callback, data, final, onError, isSubmit = false } = action.payload;

    // data should include reportId / siteId & appId

    try {
        const api = isSubmit ? API.progressReport.submitProgressReport : API.progressReport.saveProgressReport;

        const res = yield call(api, data);

        const newReportId = res.data.result?.reportId;

        callback?.(newReportId);
    } catch (error) {
        console.log('create/save progress failed:', error);
        onError?.();
    }

    final?.();
}

function* getProgressReport(action) {
    const { docType = PROGRESS_REPORT, reportId, appId, siteId, isLoading = true, final, callback, onPermissionError } = action.payload;
    const { progressReport } = yield select();

    try {
        // clear data from another form
        yield put(
            setGlobal({
                postApprovalReportData: {
                    [reportId]: {
                        showNavigationSubNo: null,
                        showNavigationStatus: null,
                    },
                },
            }),
        );
        let data = { docType };

        if (reportId) {
            data.reportId = reportId;
        } else {
            data.appId = appId;
            data.siteId = siteId;
        }

        if (isLoading) {
            yield put({
                type: SET_PROGRESS_REPORT,
                payload: {
                    isLoading: true,
                },
            });
        }

        const res = yield call(API.postApprovalActivities.getReportDetail, data);
        const detail = res.data.result;
        progressReport.remoteDetail = detail;
        progressReport.isLoading = false;

        yield put({
            type: SET_PROGRESS_REPORT,
            payload: progressReport,
        });

        callback?.(progressReport);
    } catch (error) {
        console.log('get susar report detail failed:', error);

        onPermissionError?.();
        return final?.();

        // yield put({
        //     type: SET_PROGRESS_REPORT,
        //     payload: {
        //         isLoading: false,
        //     },
        // });
    }

    final?.();
}

// function* saveSusar(action) {
//     const { callback, reportId, appId, isFormCreate } = action.payload;
//     const { susarReport } = yield select();

//     setGlobalLoading(true);
//     try {
//         const {
//             actualStudyStartDate,
//             isNotYetStarted,
//             recruitedSubjectNo,
//             totalNumberReportsSubmitted,
//             anyRecommendation,
//             isAlterationRequired,
//             addSupplements,
//             deleteSupplements,
//         } = susarReport.remoteDetail;

//         let data = {
//             actualStudyStartDate: actualStudyStartDate ? new Date(actualStudyStartDate) : null,
//             isNotYetStarted,
//             recruitedSubjectNo,
//             totalNumberReportsSubmitted,
//             isAlterationRequired,
//             anyRecommendation,
//             addSupplements,
//             deleteSupplements,
//             appId: appId ?? susarReport.remoteDetail.appId,
//         };

//         if (!isFormCreate) {
//             data.reportId = reportId;
//         }

//         const res = yield call(API.susarReport.saveSusar, data);

//         const newReportId = res.data.result.reportId;
//         callback?.(newReportId);
//     } catch (error) {
//         console.log('create/save susar failed:', error);
//     }
//     setGlobalLoading(false);
// }

// function* submitSusar(action) {
//     const { callback, reportId, appId, isFormCreate } = action.payload;
//     const { susarReport } = yield select();

//     setGlobalLoading(true);
//     try {
//         const {
//             actualStudyStartDate,
//             isNotYetStarted,
//             recruitedSubjectNo,
//             totalNumberReportsSubmitted,
//             anyRecommendation,
//             isAlterationRequired,
//             addSupplements,
//             deleteSupplements,
//         } = susarReport.remoteDetail;

//         let data = {
//             actualStudyStartDate: actualStudyStartDate ? new Date(actualStudyStartDate) : null,
//             isNotYetStarted,
//             recruitedSubjectNo,
//             totalNumberReportsSubmitted,
//             isAlterationRequired,
//             anyRecommendation,
//             addSupplements,
//             deleteSupplements,
//             appId: appId ?? susarReport.remoteDetail.appId,
//         };

//         if (!isFormCreate) {
//             data.reportId = reportId;
//         }

//         yield call(API.susarReport.submitSusar, data);

//         callback?.();
//     } catch (error) {
//         console.log('submit susar failed:', error);
//     }
//     setGlobalLoading(false);
// }

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PROGRESS_REPORT:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};
export function* watchProgressReport() {
    yield takeEvery(GET_PROGRESS_REPORT, safeSaga(getProgressReport));
    yield takeEvery(SAVE_PROGRESS_REPORT, safeSaga(saveProgressReport));
}

export default reducer;
